/** @file TODO: documentar */
import onmount from 'onmount';
import { loadCKeditor } from './load.js';

onmount('.ckeditor_textinput', async function () {
  await loadCKeditor();
  var editor = null;
  const self = this;
  const form = $(this).closest('form');
  const submit = form.find(':submit');

  if ($(this).val()) {
    crearEditor();
  }
  $(this).one('click', crearEditor);

  function crearEditor() {
    if (editor) {
      return;
    }
    editor = CKEDITOR.replace(self, {
      toolbar: [
        ['Bold','Italic','Underline','StrikeThrough','-','Undo','Redo','-','Cut','Copy','Paste','Find','Replace','-','-'],
        ['JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'],
        '/',
        ['base64image','Table','-','Link','TextColor','BGColor'], ['Styles','Format','FontSize', 'Source', 'Maximize']
      ],
      extraPlugins: 'base64image',
      uiColor: '#4682B4',
      startupFocus : true
    });

    editor.on('change', syncEditor);
    editor.on('blur', syncEditor);
  }

  function syncEditor(ev) {
    editor.updateElement();
    submit.prop('disabled', editor.getData().trim().length == 0);
    $(self).trigger(ev.name);
  }

  $(this).on('change', function () {
    var size = this.value.size/1024/1024;
    if (size > 0.3) {
      'El archivo debe pesar menos de 300kB. Por favor elegir otra imagen.';
    }
  });

});
